// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportObjects = {
	44873: function() {
		return {
			"./emojis_bg.js": {
				"__wbindgen_json_parse": function(p0i32,p1i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache0["Ct"](p0i32,p1i32);
				},
				"__wbindgen_json_serialize": function(p0i32,p1i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache1["dz"](p0i32,p1i32);
				},
				"__wbindgen_is_null": function(p0i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache2["QR"](p0i32);
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache3["vU"](p0i32);
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache4["bk"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache5["yc"](p0i32,p1i32);
				},
				"__wbg_log_6af056b79ee9ad99": function(p0i32,p1i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache6["HI"](p0i32,p1i32);
				},
				"__wbg_new_693216e109162396": function() {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache7["ky"]();
				},
				"__wbg_stack_0ddaca5d1abfb52f": function(p0i32,p1i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache8["i0"](p0i32,p1i32);
				},
				"__wbg_error_09919627ac0992f5": function(p0i32,p1i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache9["Di"](p0i32,p1i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache10["rl"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[28006].exports;
					return wasmImportedFuncCache11["Qn"](p0i32,p1i32);
				}
			}
		};
	},
	79051: function() {
		return {
			"./emojis_bg.js": {
				"__wbindgen_json_parse": function(p0i32,p1i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache12["Ct"](p0i32,p1i32);
				},
				"__wbindgen_json_serialize": function(p0i32,p1i32) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache13["dz"](p0i32,p1i32);
				},
				"__wbindgen_is_null": function(p0i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache14["QR"](p0i32);
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache15["vU"](p0i32);
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache16["bk"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache17["yc"](p0i32,p1i32);
				},
				"__wbg_log_6af056b79ee9ad99": function(p0i32,p1i32) {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache18["HI"](p0i32,p1i32);
				},
				"__wbg_new_693216e109162396": function() {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache19["ky"]();
				},
				"__wbg_stack_0ddaca5d1abfb52f": function(p0i32,p1i32) {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache20["i0"](p0i32,p1i32);
				},
				"__wbg_error_09919627ac0992f5": function(p0i32,p1i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache21["Di"](p0i32,p1i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache22["rl"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[32].exports;
					return wasmImportedFuncCache23["Qn"](p0i32,p1i32);
				}
			}
		};
	},
	35712: function() {
		return {
			"./emoji_types_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[5651].exports;
					return wasmImportedFuncCache24["bk"](p0i32);
				},
				"__wbindgen_json_parse": function(p0i32,p1i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[5651].exports;
					return wasmImportedFuncCache25["Ct"](p0i32,p1i32);
				},
				"__wbindgen_json_serialize": function(p0i32,p1i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[5651].exports;
					return wasmImportedFuncCache26["dz"](p0i32,p1i32);
				},
				"__wbindgen_object_clone_ref": function(p0i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[5651].exports;
					return wasmImportedFuncCache27["BZ"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[5651].exports;
					return wasmImportedFuncCache28["yc"](p0i32,p1i32);
				},
				"__wbg_new_a67fc3ea2a00fa35": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[5651].exports;
					return wasmImportedFuncCache29["fF"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_test_dc269309ab23994f": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[5651].exports;
					return wasmImportedFuncCache30["pt"](p0i32,p1i32,p2i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[5651].exports;
					return wasmImportedFuncCache31["Qn"](p0i32,p1i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"1212": [
		79051
	],
	"5953": [
		35712
	],
	"8554": [
		44873
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"1212":{"79051":"6472e64dba0975651c1f"},"5953":{"35712":"96400dd3063c3e4dab04"},"8554":{"44873":"fd298d44cda9db01bdfe"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};